import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SugargooSpreadsheetGuide from "../pages/article/SugargooSpreadsheetGuide";
import SugargooReviewArticle from "../pages/article/SugargooReviewArticle";
import SugargooShippingArticle from "../pages/article/SugargooShippingArticle";
import SugargooCouponArticle from "../pages/article/SugargooCouponArticle";
import SugargooBeginnersArticle from "../pages/article/SugargooBeginnersArticle";
import IsSugargooLegitArticle from "../pages/article/IsSugargooLegitArticle";
import SugargooWarehouseArticle from "../pages/article/SugargooWarehouseArticle";
import BestSugargooFindsArticle from "../pages/article/BestSugargooFindsArticle";
import SugargooQCPhotosArticle from "../pages/article/SugargooQCPhotosArticle";
import SugargooDatabaseArticle from "../pages/article/SugargooDatabaseArticle";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/sugargoo-spreadsheet-guide",
    element: <SugargooSpreadsheetGuide />,
  },
  {
    path: "/article/sugargoo-review",
    element: <SugargooReviewArticle />,
  },
  {
    path: "/article/sugargoo-shipping-cost",
    element: <SugargooShippingArticle />,
  },
  {
    path: "/article/sugargoo-coupon-guide",
    element: <SugargooCouponArticle />,
  },
  {
    path: "/article/sugargoo-beginners-guide",
    element: <SugargooBeginnersArticle />,
  },
  {
    path: "/article/is-sugargoo-legit",
    element: <IsSugargooLegitArticle />,
  },
  {
    path: "/article/sugargoo-warehouse-guide",
    element: <SugargooWarehouseArticle />,
  },
  {
    path: "/article/best-sugargoo-finds",
    element: <BestSugargooFindsArticle />,
  },
  {
    path: "/article/sugargoo-qc-photos",
    element: <SugargooQCPhotosArticle />,
  },
  {
    path: "/article/sugargoo-database",
    element: <SugargooDatabaseArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;